<template>
	<el-container class="register" :class="configStore.electronMode ? 'electron' : ''">
		<AuthBackground v-if="!configStore.electronMode" />
		<div class="register-shell">
			<AuthBrandPanel />
			<main class="form-panel">
				<el-form :model="dataForm" status-icon :rules="rules" ref="registerForm" class="form">
					<div class="form-header">
						<h1 class="form-title">{{ $t('register.pageTitle') }}</h1>
					</div>
					<div v-if="modes.length > 1" class="mode-nav">
						<button v-for="mode in modes" :key="mode" type="button" class="mode-nav-item"
							:class="{ active: dataForm.mode === mode }" @click="switchMode(mode)">
							<i class="iconfont" :class="'icon-' + mode"></i>
							<span>{{ tabNameMap[mode] }}</span>
						</button>
					</div>
					<div class="form-body">
						<transition name="form-fade" mode="out-in">
							<div :key="dataForm.mode" class="form-fields">
								<el-form-item v-if="dataForm.mode == 'phone'" prop="phone" :label="$t('register.phone')">
									<el-input v-model="dataForm.phone" :placeholder="$t('register.phone')"
										prefix-icon="el-icon-mobile-phone" maxlength="20"></el-input>
								</el-form-item>
								<el-form-item v-if="dataForm.mode == 'phone'" prop="code" :label="$t('register.smsCode')">
									<div class="code-field">
										<el-input v-model="dataForm.code" :placeholder="$t('register.smsCode')"
											maxlength="6" prefix-icon="el-icon-key"></el-input>
										<span class="lock-text" v-if="phoneLockTime > 0">{{ $t('register.resendAfter', { n: phoneLockTime }) }}</span>
										<button v-else type="button" class="code-link" @click="onSendSmsCode">{{ $t('register.getCode') }}</button>
									</div>
								</el-form-item>
								<el-form-item v-if="dataForm.mode == 'email'" prop="email" :label="$t('register.email')">
									<el-input v-model="dataForm.email" :placeholder="$t('register.email')"
										prefix-icon="el-icon-message" maxlength="20"></el-input>
								</el-form-item>
								<el-form-item v-if="dataForm.mode == 'email'" prop="code" :label="$t('register.emailCode')">
									<div class="code-field">
										<el-input v-model="dataForm.code" :placeholder="$t('register.emailCode')"
											maxlength="6" prefix-icon="el-icon-key"></el-input>
										<span class="lock-text" v-if="emailLockTime > 0">{{ $t('register.resendAfter', { n: emailLockTime }) }}</span>
										<button v-else type="button" class="code-link" @click="onSendMailCode">{{ $t('register.getCode') }}</button>
									</div>
								</el-form-item>
								<el-form-item prop="userName" :label="$t('register.userName')">
									<el-input v-model="dataForm.userName" maxlength="20" :placeholder="$t('register.userName')"
										prefix-icon="el-icon-user"></el-input>
								</el-form-item>
								<el-form-item prop="password" :label="$t('register.password')">
									<el-input :type="isShowPwd ? 'text' : 'password'" v-model="dataForm.password" maxlength="20"
										:placeholder="$t('register.password')" prefix-icon="el-icon-lock">
										<template #suffix>
											<i :class="isShowPwd ? 'icon-pwd-show' : 'icon-pwd-hide'" @click="switchPassword"
												class="iconfont password-switch-icon"></i>
										</template>
									</el-input>
								</el-form-item>
								<el-form-item v-if="dataForm.mode == 'username'" prop="confirmPassword"
									:label="$t('register.confirmPassword')">
									<el-input :type="isShowConfirmPwd ? 'text' : 'password'" v-model="dataForm.confirmPassword"
										maxlength="20" :placeholder="$t('register.confirmPassword')" prefix-icon="el-icon-lock">
										<template #suffix>
											<i :class="isShowConfirmPwd ? 'icon-pwd-show' : 'icon-pwd-hide'"
												@click="switchConfirmPassword" class="iconfont password-switch-icon"></i>
										</template>
									</el-input>
								</el-form-item>
							</div>
						</transition>
						<el-button class="submit-btn" type="primary" @click="submitForm()">{{ $t('register.register') }}</el-button>
					</div>
					<div class="form-footer">
						<span class="footer-text">{{ $t('register.hasAccount') }}</span>
						<router-link class="footer-link" to="/login">{{ $t('register.loginNow') }}</router-link>
					</div>
				</el-form>
			</main>
		</div>
		<!-- <icp></icp> -->
		<captcha-image ref="captchaRef"></captcha-image>
	</el-container>
</template>

<script>
import AuthBackground from '../components/common/AuthBackground.vue'
import AuthBrandPanel from '../components/common/AuthBrandPanel.vue'
import CaptchaImage from '../components/common/CaptchaImage.vue'
import Icp from '../components/common/Icp.vue'
import { saveLoginSession } from '../api/auth.js'

export default {
	name: "register",
	components: {
		AuthBackground,
		AuthBrandPanel,
		CaptchaImage,
		Icp
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('register.inputPhone')));
			}
			const regex = /^1[3-9]\d{9}$/;
			if (!regex.test(value)) {
				return callback(new Error(this.$t('register.phoneFormatError')));
			}
			callback();
		};
		var checkEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('register.inputEmail')));
			}
			const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			if (!regex.test(value)) {
				return callback(new Error(this.$t('register.emailFormatError')));
			}
			callback();
		};
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('register.inputUserName')));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error(this.$t('register.inputPassword')));
			}
			callback();
		};
		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error(this.$t('register.inputConfirmPassword')));
			}
			if (value != this.dataForm.password) {
				return callback(new Error(this.$t('register.passwordMismatch')));
			}
			callback();
		};
		return {
			dataForm: {
				phone: '',
				email: '',
				code: '',
				mode: 'username',
				userName: '',
				password: '',
				confirmPassword: ''
			},
			// 密码显示状态
			isShowPwd: false,
			isShowConfirmPwd: false,
			rules: {
				phone: [{
					validator: checkPhone,
					trigger: 'submit'
				}],
				email: [{
					validator: checkEmail,
					trigger: 'submit'
				}],
				userName: [{
					validator: checkUserName,
					trigger: 'submit'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'submit'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'submit'
				}]
			},
			showCaptchaImage: false,
			phoneLockTime: 0,
			phoneLockTimer: null,
			emailLockTime: 0,
			emailLockTimer: null
		};
	},
	methods: {
		submitForm() {
			this.$refs.registerForm.validate((valid) => {
				if (valid) {
					this.$http({
						url: "/register",
						method: 'post',
						data: this.dataForm
					}).then(() => {
						// 注册成功后自动登录
						this.autoLogin();
					})
				}
			});
		},
		// 自动登录
		autoLogin() {
			// 根据注册模式确定登录用户名
			let loginUserName = '';
			if (this.dataForm.mode === 'phone') {
				loginUserName = this.dataForm.phone;
			} else if (this.dataForm.mode === 'email') {
				loginUserName = this.dataForm.email;
			} else {
				loginUserName = this.dataForm.userName;
			}

			// 调用登录接口
			this.$http({
				url: "/login",
				method: 'post',
				data: {
					terminal: this.$enums.TERMINAL_TYPE.WEB,
					userName: loginUserName,
					password: this.dataForm.password
				}
			}).then((data) => {
				saveLoginSession(data, {
					autoLogin: true,
					userName: loginUserName
				});
				this.$message.success(this.$t('register.registerSuccess', { name: process.env.VUE_APP_NAME }));
				// 跳转到主页
				this.$router.push("/home/chat");
			})
		},
		onSendSmsCode() {
			this.$refs.registerForm.validateField('phone', (valid) => {
				if (valid == '') {
					// 发短信前先验证验证码，防止盗刷
					this.$refs.captchaRef.open((id, code) => {
						// 60s内不允许再次发送
						this.phoneLockTime = 60;
						this.phoneLockTimer && clearInterval(this.phoneLockTimer);
						this.phoneLockTimer = setInterval(() => {
							this.phoneLockTime -= 1;
							if (this.phoneLockTime <= 0) {
								this.phoneLockTimer && clearInterval(this.phoneLockTimer);
							}
						}, 1000)
						// 发送短信
						let data = {
							phone: this.dataForm.phone,
							id: id,
							code: code
						}
						this.$http({
							url: "/captcha/sms/code",
							method: 'post',
							data: data
						}).then(() => {
							this.$message.success(this.$t('register.smsSent'))
						})
					});
				}
			})
		},
		onSendMailCode() {
			this.$refs.registerForm.validateField('email', (valid) => {
				if (valid == '') {
					// 60s内不允许再次发送
					this.emailLockTime = 60;
					this.emailLockTimer && clearInterval(this.emailLockTimer);
					this.emailLockTimer = setInterval(() => {
						this.emailLockTime -= 1;
						if (this.emailLockTime <= 0) {
							this.emailLockTimer && clearInterval(this.emailLockTimer);
						}
					}, 1000)
					// 发送短信
					let data = {
						email: this.dataForm.email,
					}
					this.$http({
						url: "/captcha/mail/code",
						method: 'post',
						data: data
					}).then(() => {
						this.$message.success(this.$t('register.emailSent'))
					})

				}
			})
		},
		switchMode(mode) {
			this.dataForm.mode = mode;
			this.$refs.registerForm.resetFields();
		},
		// 切换密码显示状态
		switchPassword() {
			this.isShowPwd = !this.isShowPwd;
		},
		// 切换确认密码显示状态
		switchConfirmPassword() {
			this.isShowConfirmPwd = !this.isShowConfirmPwd;
		}
	},
	computed: {
		config() {
			return this.configStore.registration;
		},
		tabNameMap() {
			return {
				username: this.$t('register.tabUsername'),
				phone: this.$t('register.tabPhone'),
				email: this.$t('register.tabEmail')
			};
		},
		modes() {
			return this.config.mode || [];
		}
	},
	watch: {
		config: {
			handler() {
				this.switchMode(this.config.mode[0]);
			}
		}
	},
	mounted() {
		this.configStore.loadConfig().then(() => {
			if (this.config.mode) {
				this.switchMode(this.config.mode[0]);
			}
		})
	}
}
</script>

<style scoped lang="scss">
.register {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	background: #f3f7ff;
	overflow: auto;
	padding: 32px 24px;
	box-sizing: border-box;

	.register-shell {
		position: relative;
		z-index: 1;
		display: flex;
		width: 100%;
		max-width: 920px;
		min-height: 560px;
		background: #fff;
		border-radius: 20px;
		box-shadow: 0 24px 64px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(15, 23, 42, 0.04);
		overflow: hidden;
	}

	.form-panel {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 40px 44px;
		min-width: 0;
	}

	.form {
		width: 100%;
		max-width: 380px;
	}

	.form-header {
		margin-bottom: 24px;
	}

	.form-title {
		margin: 0;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.3;
		color: #152443;
	}

	.mode-nav {
		display: flex;
		gap: 4px;
		margin-bottom: 24px;
		border-bottom: 1px solid #d9e0f0;
	}

	.mode-nav-item {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 0 4px 12px;
		margin-right: 20px;
		border: none;
		background: transparent;
		cursor: pointer;
		font-size: 14px;
		color: var(--im-text-color-lighter);
		position: relative;
		transition: color 0.2s ease;

		.iconfont {
			font-size: 15px;
		}

		&::after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			bottom: -1px;
			height: 2px;
			background: var(--im-color-primary);
			border-radius: 2px 2px 0 0;
			transform: scaleX(0);
			transition: transform 0.2s ease;
		}

		&.active {
			color: var(--im-color-primary);
			font-weight: 600;

			&::after {
				transform: scaleX(1);
			}
		}

		&:hover:not(.active) {
			color: var(--im-text-color-light);
		}
	}

	.form-body {
		::v-deep .el-form-item {
			margin-bottom: 18px;

			.el-form-item__label {
				float: none;
				display: block;
				text-align: left;
				line-height: 1.4;
				padding: 0 0 6px;
				font-size: 13px;
				font-weight: 500;
				color: #152443;
			}

			.el-form-item__content {
				line-height: 1;
			}

			.el-input__inner {
				height: 44px;
				border-radius: 10px;
				border: 1px solid #d9e0f0;
				background: #fafbfd;
				padding-left: 40px;
				font-size: 14px;
				transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

				&:hover {
					border-color: #c7d4e8;
				}

				&:focus {
					border-color: var(--im-color-primary);
					background: #fff;
					box-shadow: 0 0 0 3px rgba(65, 105, 222, 0.12);
				}

				&::placeholder {
					color: var(--im-text-color-lighter-extra);
				}
			}

			.el-input__prefix {
				left: 12px;

				.el-input__icon {
					color: #94a3b8;
					font-size: 16px;
					line-height: 44px;
				}
			}

			.el-input__suffix {
				right: 12px;

				.password-switch-icon {
					cursor: pointer;
					color: #94a3b8;
					font-size: 16px;
					transition: color 0.2s ease;

					&:hover {
						color: var(--im-color-primary);
					}
				}
			}
		}
	}

	.code-field {
		display: flex;
		align-items: center;
		gap: 12px;

		::v-deep .el-input {
			flex: 1;
			min-width: 0;
		}

		.lock-text {
			flex-shrink: 0;
			font-size: 12px;
			color: var(--im-text-color-lighter);
			white-space: nowrap;
		}

		.code-link {
			flex-shrink: 0;
			border: none;
			background: transparent;
			padding: 0;
			font-size: 13px;
			font-weight: 500;
			color: var(--im-color-primary);
			cursor: pointer;
			white-space: nowrap;
			transition: opacity 0.2s ease;

			&:hover {
				opacity: 0.8;
			}

			&:disabled {
				opacity: 0.5;
				cursor: not-allowed;
			}
		}
	}

	.submit-btn {
		width: 100%;
		height: 46px;
		margin-top: 8px;
		border-radius: 10px;
		border: none;
		font-size: 15px;
		font-weight: 600;
		letter-spacing: 0.5px;
		transition: transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			transform: translateY(-1px);
			box-shadow: 0 8px 20px rgba(65, 105, 222, 0.28);
		}
	}

	.form-footer {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 6px;
		margin-top: 24px;
		padding-top: 20px;
		border-top: 1px solid #eef2f7;
	}

	.footer-text {
		font-size: 13px;
		color: var(--im-text-color-lighter);
	}

	.footer-link {
		font-size: 13px;
		font-weight: 600;
		color: var(--im-color-primary);
		text-decoration: none;
		transition: opacity 0.2s ease;

		&:hover {
			opacity: 0.85;
		}
	}

	.form-fade-enter-active,
	.form-fade-leave-active {
		transition: opacity 0.18s ease, transform 0.18s ease;
	}

	.form-fade-enter,
	.form-fade-leave-to {
		opacity: 0;
		transform: translateY(6px);
	}

	&.electron {
		background: #fff;
		padding-top: 25px;
		box-sizing: border-box;
		height: 100%;
		overflow: hidden;

		.register-shell {
			width: 100%;
			height: 100%;
			max-width: none;
			min-height: 0;
			border-radius: 0;
			box-shadow: none;
		}

		:deep(.auth-brand-panel) {
			flex: 0 0 380px;
			padding: 36px 32px;
		}

		.form-panel {
			flex: 1;
			padding: 24px 32px;
			justify-content: center;
			align-items: center;
			overflow-y: auto;
		}

		.form-header {
			margin-bottom: 16px;
		}

		.mode-nav {
			margin-bottom: 16px;
		}

		.form-body {
			::v-deep .el-form-item {
				margin-bottom: 14px;
			}
		}

		.form-footer {
			margin-top: 16px;
			padding-top: 16px;
		}
	}

	@media (max-width: 860px) {
		&:not(.electron) {
			padding: 16px;

			.register-shell {
				flex-direction: column;
				max-width: 440px;
				min-height: auto;
			}

			:deep(.auth-brand-panel) {
				display: none;
			}

			.form-panel {
				padding: 28px 24px 32px;
			}
		}
	}
}
</style>